module.exports = __webpack_public_path__ + "img/clock.35128297.svg";